import defaultProps from './defaultProps';
import mock from './mock';
import propTypes from './propTypes';

const Image = {
	DefaultProps: defaultProps,
	Mock: mock,
	PropTypes: propTypes,
};

export default Image;
